import { IonContent } from "@ionic/react"
//import { useEffect, useRef } from "react"
//import { useAppDispatch } from '../../redux/hooks'
//import { updateSequence } from "../../features/signin/signinSequence"

const Blank: React.FC = () => {

  //  const dispatch = useAppDispatch()

   // const containerRef = useRef<HTMLDivElement>(null)

    // useEffect(() => {
    //     const element = containerRef.current
    //     if (element) {
    //         element.click();
    //     }
    //     console.log('Blank dispatching updateSequence...')
    //     dispatch(updateSequence())
        
    // }, [])
  
    return (
        <IonContent class="signin-page">
            <div></div>
        </IonContent>
    )
}

export default Blank